/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Legacy_SummaryInputs */



/**
* | output |
* | --- |
* | "Code for version 1.8.50 or earlier" |
*
* @param {Offline_Activation_Legacy_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_legacy_summary = /** @type {((inputs?: Offline_Activation_Legacy_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Legacy_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code pour la version 1.8.50 ou antérieure")
	if (locale === "de") return /** @type {LocalizedString} */ ("Code für Version 1.8.50 oder älter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice per la versione 1.8.50 o precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Код для версии 1.8.50 или более ранней")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código para la versión 1.8.50 o anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("适用于 1.8.50 或更早版本的代码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バージョン 1.8.50 以前用のコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संस्करण 1.8.50 या पहले के लिए कोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código para a versão 1.8.50 ou anterior")
	return /** @type {LocalizedString} */ ("Code for version 1.8.50 or earlier")
});